import styled, { css } from 'styled-components'

export const SectionWrapper = styled.div<{
  padding: number
  dropShadow: boolean
  transparency: number
}>`
  position: relative;
  min-height: 160px;
  border-radius: 6px;
  padding: ${({ padding }) => padding || 0}px;
  background: rgba(255, 255, 255, ${({ transparency }) => transparency});

  ${({ dropShadow }) =>
    dropShadow &&
    css`
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
    `};
`

export const SectionTitle = styled.div<{ padding: number }>`
  height: 50px;
  font-size: 22px;
  border-bottom: 1px solid lightgray;
  margin-bottom: 16px;
`

export const WidgetsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-right: -16px;
`
